export const CLIP_PATH_ID = 'clip'
export const CLIP_PATH_URL = `url(#${CLIP_PATH_ID})`

export const DEFAULT_OBJECT_SIZE = 20
export const MAP_SIZE = 300
